import { render, staticRenderFns } from "./ModuleParameterization.vue?vue&type=template&id=57c68483&scoped=true&"
import script from "./ModuleParameterization.vue?vue&type=script&lang=js&"
export * from "./ModuleParameterization.vue?vue&type=script&lang=js&"
import style0 from "./ModuleParameterization.vue?vue&type=style&index=0&id=57c68483&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c68483",
  null
  
)

export default component.exports